import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { NpUserSyncPage } from '@features/admin/np-sync';

const searchSchema = z.object({
  // UP_TO_DATE se v tabulce neukazuje (backend ty radky neposila).
  state: z.enum(['ALL', 'NEW_USER', 'NEW_ASSIGNMENT', 'AMBIGUOUS_LOGIN', 'UNKNOWN_PORTAL']).optional().default('ALL'),
  // Hledani ve firme, loginu a jmenu.
  q: z.string().optional(),
});

export type AdminNpUserSyncSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute('/admin/np-user-sync/')({
  validateSearch: search => searchSchema.parse(search),
  component: RouteComponent,
});

function RouteComponent() {
  return <NpUserSyncPage />;
}
